import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import type { AdResult } from '../../data/AdFragment'
import { useAuth } from '../../user/UserContext'
import { RegisterBanner } from '../static/RegisterBanner'
import style from './AdContent.module.sass'
import { Hidden } from './Hidden'

type AdContentProps = {
	ads: AdResult[]
	isAlignedLeft?: boolean
	isAlignedRight?: boolean
	withContentAbove?: boolean
	isBannerHidden?: boolean
}

export const AdContent: FunctionComponent<AdContentProps> = ({
	ads,
	isAlignedLeft = false,
	isAlignedRight = false,
	withContentAbove = false,
	isBannerHidden = false,
}) => {
	const auth = useAuth()

	const router = useRouter()
	const registerBannerHidden =
		router.asPath.includes(InternalLink.Results) || router.asPath.includes(InternalLink.MyResults) || isBannerHidden

	return (
		<Hidden breakpoint="desktopDown">
			<div
				className={clsx(
					style.root,
					withContentAbove && style.rootMarginTop,
					isAlignedRight && style.rootMarginRight,
					isAlignedLeft && style.rootMarginLeft,
				)}
			>
				{auth.status === 'signedOut' && !registerBannerHidden && (
					<div className={style.bannerContent}>
						<div className={style.staticBannerWrapper}>
							<RegisterBanner thin vertical isAlignedLeft={isAlignedLeft} isAlignedRight={isAlignedRight} />
						</div>
					</div>
				)}
				{ads.length > 0 &&
					ads.map(
						(ad) =>
							ad.link &&
							ad.image?.url && (
								<Link href={ad.link} key={ad.link} title={ad.image.alt} className={style.adWrapper}>
									<NextImage
										src={ad.image.url}
										alt={ad.image.alt ?? ''}
										title={ad.image.alt}
										layout="fill"
										objectFit="cover"
										sizes="260px"
									/>
								</Link>
							),
					)}
			</div>
		</Hidden>
	)
}
